import { InjectionToken } from '@angular/core';

export const WEB_CONFIG = new InjectionToken<Config>('WEB_CONFIG');

export interface Config {
  // tslint:disable-next-line:variable-name
  api_url: string;
  env: string;
}

export const DEFAULT_WEB_CONFIG: Config = {
  api_url: 'http://localhost:8080',
  env: 'DEV'
};
